import { render, staticRenderFns } from "./community-dynamic.vue?vue&type=template&id=42b7ce20&scoped=true&"
import script from "./community-dynamic.vue?vue&type=script&lang=js&"
export * from "./community-dynamic.vue?vue&type=script&lang=js&"
import style0 from "./community-dynamic.vue?vue&type=style&index=0&id=42b7ce20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b7ce20",
  null
  
)

export default component.exports